module.exports = __webpack_public_path__ + "img/mail.91c03a62.svg";